import { Avatar } from 'components/Avatar/Avatar';
import { AvatarGroup } from 'components/Avatar/AvatarGroup';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { viewUserProfileRoute } from 'modules/userProfile/routing/userProfile.routes';

import { useCmsReactionsContext } from './CmsReactionsContext';
import { CmsReactionsProfileInfoCard } from './ProfileInfoCard/CmsReactionsProfileInfoCard';

export function CmsLatestReactionAvatars() {
  const { latestReactions } = useCmsReactionsContext();

  if (latestReactions.length === 0) return null;

  return (
    <AvatarGroup $stacked data-qa-id="cms-latest-reaction-avatars">
      {latestReactions.map((reaction) => (
        <Tooltip
          key={reaction.user.id}
          content={
            <CmsReactionsProfileInfoCard
              url={viewUserProfileRoute.with({
                username: reaction.user.profile.username,
              })}
              name={reaction.user.profile.name}
              image={reaction.user.profile.image}
              location={reaction.user.profile.location}
              summary={reaction.user.profile.summary}
            />
          }
          size="large"
          tooltipWidth="480px"
          placement="top-right"
        >
          <div data-qa-id="cms-latest-reaction-avatar">
            <Avatar
              border="white"
              image={reaction.user.profile.image}
              name={reaction.user.profile.name}
              size="xs"
            />
          </div>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
}
